export const en = {
  // global
  app_name: "CRUNCHALPHA",
  dashboard: "Dashboard",
  environment_dummy: "Environment: DUMMY",
  dummy_banner: "Frontend REAL — Connected to API backend.",
  back_to_dashboard: "Back to Dashboard",
  open_performance: "Open Performance →",
  dummy_first: "Dummy-first",
  next_real_data: "Next (Real Data)",
  placeholder_note:
    "Placeholder only. Later AlphaRank engine fills AlphaScore / Grade / Flags (P1–P7 + 20 metrics).",

  // common labels
  tier: "Tier",
  risk: "Risk",
  grade: "Grade",
  alpha_score: "AlphaScore",
  trades: "Trades",
  win_rate: "Win Rate",
  pf: "PF",
  max_dd: "Max DD",

  // trader dashboard
  trader_dashboard: "Trader Dashboard",
  capital_snapshot: "Capital Snapshot",
  equity: "Equity",
  balance: "Balance",
  pnl_today: "PnL Today",
  total_trades_closed: "Total Trades (Closed)",
  max_drawdown: "Max Drawdown",
  profit_factor: "Profit Factor",

  survivability: "Survivability",
  scalability: "Scalability",
  moderate: "Moderate",

  pillars_title: "7 Pillars (P1–P7)",
  score_weighted: "Score 0–100 — Weighted",

  risk_flags: "Risk Flags",
  retail_note: "Retail: show risk, not approve",

  metrics_title: "20 Metrics (Underlying)",
  explainable_basis: "Explainable basis for pillars",

  regime_title: "Regime (Phase-1 lightweight)",
  confidence: "Confidence",

  // performance page tabs
  summary: "Summary",
  equity_curve: "Equity Curve",
  drawdown: "Drawdown",
  trades_tab: "Trades",

  // performance sections
  alpha_rank_snapshot: "AlphaRank Snapshot",
  core_pnl: "Core PnL",
  net_profit: "Net Profit",
  gross_profit: "Gross Profit",
  gross_loss: "Gross Loss",

  risk_behaviour: "Risk & Behaviour",
  max_dd_amount: "Max DD (Amount)",
  avg_hold: "Avg Hold",
  win_loss: "Win / Loss",
};
